import { useDataProvider } from "react-admin";
import { useQuery } from "react-query";

import {
  ActiveUserCountsForFinancesResponse,
  CustomDataProvider,
} from "../../../../types";
import { ChartContainer, LineChart } from "../../../custom";
import { analyticsUtils } from "../../analytics-utils";

function ProjectsChart() {
  const dataProvider = useDataProvider<CustomDataProvider>();

  const { data } = useQuery<{
    data: ActiveUserCountsForFinancesResponse[];
  }>(["getActiveUserCountsForFinances"], () =>
    dataProvider.getActiveUserCountsForFinances(),
  );

  if (data?.data) {
    const processedData = analyticsUtils.processData(
      data.data,
      new ActiveUserCountsForFinancesResponse(),
      30,
    );

    return (
      <ChartContainer title="Projects">
        <LineChart
          labels={processedData.map(
            (d: ActiveUserCountsForFinancesResponse) => d.date,
          )}
          datasets={[
            {
              data: processedData.map(
                (d: ActiveUserCountsForFinancesResponse) => d.active_projects,
              ),
              label: "Active",
            },
            {
              data: processedData.map(
                (d: ActiveUserCountsForFinancesResponse) =>
                  d.contender_projects,
              ),
              label: "Contender",
            },
            {
              data: processedData.map(
                (d: ActiveUserCountsForFinancesResponse) => d.paying_projects,
              ),
              label: "Paying",
            },
          ]}
        />
      </ChartContainer>
    );
  } else {
    return null;
  }
}

export default ProjectsChart;
